// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model_card[data-v-5c35f369] {
  border-radius: 10px;
  max-width: 500px;
}
.model_card img[data-v-5c35f369] {
  max-height: 150px;
}
.model_card h2[data-v-5c35f369] {
  font-size: 50px;
  opacity: 0.4;
}
.model_card p[data-v-5c35f369] {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiSelectedModel.vue","webpack://./AiSelectedModel.vue"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,gBAAA;ACAF;ADFA;EAKI,iBAAA;ACAJ;ADLA;EASI,eAAA;EACA,YAAA;ACDJ;ADTA;EAcI,eAAA;ACFJ","sourcesContent":["\n.model_card {\n  border-radius: 10px;\n  max-width: 500px;\n\n  img {\n    max-height: 150px;\n  }\n\n  h2 {\n    font-size: 50px;\n    opacity: 0.4;\n  }\n\n  p {\n    font-size: 20px;\n  }\n\n}\n",".model_card {\n  border-radius: 10px;\n  max-width: 500px;\n}\n.model_card img {\n  max-height: 150px;\n}\n.model_card h2 {\n  font-size: 50px;\n  opacity: 0.4;\n}\n.model_card p {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
